import ApiClient from '@afosto/api/ApiClient';

class Organisations {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create a new organisation
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Create an organisation
   * @returns {Promise}
   */
  createOrganisation(body, options = {}) {
    return this.apiClient.request({
      url: `/rel/organisations`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Delete an organisation
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description delete an existing organisation
   * @returns {Promise}
   */
  deleteOrganisation(id, options = {}) {
    return this.apiClient.request({
      url: `/rel/organisations/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get list of organisations
   *
   * @param {Object} options - The additional request options
   * @description Returns a list of organisation information
   * @returns {Promise}
   */
  listOrganisations(options = {}) {
    return this.apiClient.request({
      url: `/rel/organisations`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Update an organisation
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Updates an existing organisation
   * @returns {Promise}
   */
  updateOrganisation(id, body, options = {}) {
    return this.apiClient.request({
      url: `/rel/organisations/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * View a single organisation
   *
   * @param {string} id
   * @param {Object} query - The optional path parameters
   * @param {string} [query.version]
   * @param {Object} options - The additional request options
   * @description Returns a single organisation by id
   * @returns {Promise}
   */
  viewOrganisation(id, query = {}, options = {}) {
    const params = {
      version: query.version,
    };

    return this.apiClient.request({
      url: `/rel/organisations/${id}`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * View a list of versions for a a single organisation
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Returns a version list for the organisation
   * @returns {Promise}
   */
  viewOrganisationVersions(id, options = {}) {
    return this.apiClient.request({
      url: `/rel/organisations/${id}/versions`,
      method: 'get',
      ...options,
    });
  }
}

export const organisations = new Organisations();

export default Organisations;
